/**
 * @generated SignedSource<<ba7c448ece9f29973d28fc49353cbcbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary$data = {
  readonly accepted: number;
  readonly rejected: number;
  readonly total: number;
  readonly unanswered: number;
  readonly " $fragmentType": "WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary";
};
export type WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary$key = {
  readonly " $data"?: WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accepted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unanswered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "type": "IntegrationTurnpikeSummary",
  "abstractKey": null
};

(node as any).hash = "875c48da6a22330e18a4c4712d49609b";

export default node;
